import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { addActivity } from '@/services/marketing/activity';
import Cookie from 'js-cookie';
import { Tree } from 'ant-design-vue';
import { TreeSelect } from 'ant-design-vue';
import FooterToolBar from '@/components/tool/FooterToolBar';
import importfailed from '@/components/importfailed/index';
export default {
  name: 'IntegralDoubling',
  i18n: require('../i18n-activity'),
  components: {
    TreeSelect: TreeSelect,
    Tree: Tree,
    FooterToolBar: FooterToolBar,
    importfailed: importfailed
  },
  props: {
    basicInformation: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;
    // let propnumberValidatePass = (rule, value, callback) => {
    // 	if (this.modalValue.productNum === '' || this.modalValue.productNum === null || this.modalValue
    // 		.productNum === 0) {
    // 		//请输入参与件数
    // 		callback(new Error(this.$t('activity.propnumber')));
    // 	} else {
    // 		callback()
    // 	}
    // };

    var activityContentValidatePass = function activityContentValidatePass(rule, value, callback) {
      if (_this.chooseproductparam.activityContent === '' || _this.chooseproductparam.activityContent === null || _this.chooseproductparam.activityContent === 0) {
        //请输入积分倍数
        callback(new Error(_this.$t('activity.multipleprop')));
      } else {
        callback();
      }
    };
    return {
      selectedRowKeys: [],
      defaultLangObj: JSON.parse(localStorage.defaultLangObj),
      rightCurrencySymbol: localStorage.rightCurrencySymbol,
      leftCurrencySymbol: localStorage.leftCurrencySymbol,
      rangeRules: {
        activityContent: [{
          required: true,
          validator: activityContentValidatePass,
          // message: this.$t('activity.discountprop'),
          trigger: 'blur'
        }]
      },
      importObj: {},
      importVisible: false,
      files: '',
      newheaders: {
        headers: ''
      },
      action: process.env.VUE_APP_API_BASE_URL + "/activity/importGoods/",
      buttonType: 2,
      dialogStatus: '',
      textMap: {
        batchoff: this.$t('activity.batchintegral'),
        batchnumber: this.$t('public.batchnumber'),
        batchinvalid: this.$t('public.batchremove')
      },
      /* 弹框验证 */
      modalRules: {
        // productNum: [{
        // 	required: true,
        // 	validator: propnumberValidatePass,
        // 	trigger: 'blur',
        // }],
        discount: [{
          required: true,
          message: this.$t('activity.multipleprop'),
          trigger: 'blur'
        }]
      },
      chooseproductparam: {
        //商品类型
        productType: 1,
        //积分倍数
        activityContent: '',
        checkedKeys: [],
        //限购设置类型
        buyLimit: 0,
        //限购设置的数量
        buyLimitNum: 0
      },
      limitdis: false,
      //有订单的活动是进行中的不能修改商品范围
      redioDisabled: false,
      //如果有新增的商品存入的值
      addProductIds: [],
      crrentPageProductList: [],
      //选中的商品list
      selectProductList: [],
      //失效的商品ids
      deleteProductIds: [],
      //新增的商品ids
      productIds: [],
      removeTypeVisible: false,
      modalValue: {
        removeType: 0,
        productNum: '',
        discount: ''
      },
      selectNumber: 0,
      listTotal: 0,
      queryParam: {
        page: 1,
        size: 5
      },
      updateLoading: false,
      visible: false,
      productList: [],
      isTableLoading: false,
      yesAvailableList: [],
      notAvailableList: [],
      sortedInfo: {
        columnKey: 'productStatus',
        order: "ascend"
      }
    };
  },
  watch: {
    'selectProductList': function selectProductList() {
      // console.log(this.selectProductList)
      this.selectNumber = this.selectProductList.length;
    },
    'chooseproductparam.activityContent': function chooseproductparamActivityContent() {
      if (this.chooseproductparam.activityContent == '' || this.chooseproductparam.activityContent == 0) {
        this.$refs.rangeRuleForm.validateField(["activityContent"]);
      }
    }
  },
  activated: function activated() {
    this.newheaders = {
      "x-auth-token": Cookie.get("x-auth-token")
    };
  },
  created: function created() {
    this.newheaders = {
      "x-auth-token": Cookie.get("x-auth-token")
    };
  },
  computed: {
    columns: function columns() {
      var sortedInfo = this.sortedInfo;
      sortedInfo = sortedInfo || {};
      if (this.chooseproductparam.productType == 2) {
        var _columns = [{
          title: this.$t('publicuse.goodsno'),
          dataIndex: 'productNo',
          key: 'productNo',
          width: '15%'
        }, {
          dataIndex: 'productName',
          key: 'productName',
          width: '35%',
          slots: {
            title: 'goodsnametitle' //自定义标头
          },
          scopedSlots: {
            customRender: 'goodsname' //自定义表格里面的内容
          },
          ellipsis: true
        },
        // {
        // 	title: this.$t('publicuse.status'),
        // 	dataIndex: 'productStatus',
        // 	key: 'productStatus',
        // 	width: '100px',
        // 	className: 'status-class',
        // 	scopedSlots: {
        // 		customRender: 'product-status', //自定义表格里面的内容
        // 	},
        // 	defaultSortOrder: 'ascend',
        // 	sorter: (a, b) => a.productStatus - b.productStatus,
        // 	sortOrder: sortedInfo.columnKey === 'productStatus' && sortedInfo.order
        // }, 
        {
          title: this.$t('publicuse.pricetax'),
          dataIndex: 'productPrice',
          key: 'productPrice',
          width: '13%',
          scopedSlots: {
            customRender: 'pricetax'
          },
          align: 'right'
        }, {
          title: this.$t('activity.originalintegral'),
          dataIndex: 'productPointNum',
          key: 'productPointNum',
          width: '15%',
          align: 'right'
        }, {
          title: this.$t('activity.inventoryquantity'),
          dataIndex: 'productStockNum',
          key: 'productStockNum',
          width: '12%',
          align: 'right'
        }, {
          title: this.$t('publicuse.action'),
          dataIndex: 'action',
          key: 'action',
          width: '10%',
          scopedSlots: {
            customRender: 'action'
          },
          align: 'center'
        }];
        return _columns;
      } else {
        var _columns2 = [{
          title: this.$t('publicuse.goodsno'),
          dataIndex: 'productNo',
          key: 'productNo',
          width: '10%'
        }, {
          dataIndex: 'productName',
          key: 'productName',
          width: '30%',
          slots: {
            title: 'goodsnametitle' //自定义标头
          },
          scopedSlots: {
            customRender: 'goodsname' //自定义表格里面的内容
          },
          ellipsis: true
        },
        // {
        // 	title: this.$t('publicuse.status'),
        // 	dataIndex: 'productStatus',
        // 	key: 'productStatus',
        // 	width: '100px',
        // 	className: 'status-class',
        // 	scopedSlots: {
        // 		customRender: 'product-status', //自定义表格里面的内容
        // 	},
        // 	defaultSortOrder: 'ascend',
        // 	sorter: (a, b) => a.productStatus - b.productStatus,
        // 	sortOrder: sortedInfo.columnKey === 'productStatus' && sortedInfo.order
        // }, 
        {
          title: this.$t('publicuse.pricetax'),
          dataIndex: 'productPrice',
          key: 'productPrice',
          width: '10%',
          align: 'right',
          scopedSlots: {
            customRender: 'pricetax'
          }
        }, {
          title: this.$t('activity.originalintegral'),
          dataIndex: 'productPointNum',
          key: 'productPointNum',
          width: '15%',
          align: 'right'
        }, {
          title: this.$t('activity.activityintegral'),
          dataIndex: 'activityContent',
          key: 'activityContent',
          width: '15%',
          scopedSlots: {
            customRender: 'activity-content' //自定义表格里面的内容
          },
          align: 'center'
        },
        // {
        // 	title: this.$t('activity.numberofparticipants'),
        // 	dataIndex: 'productNum',
        // 	key: 'productNum',
        // 	width: '13%',
        // 	scopedSlots: {
        // 		customRender: 'product-num', //自定义表格里面的内容
        // 	},
        // 	className: 'column-number',
        // }, 
        {
          title: this.$t('activity.inventoryquantity'),
          dataIndex: 'productStockNum',
          key: 'productStockNum',
          width: '10%',
          align: 'right'
        }, {
          title: this.$t('publicuse.action'),
          dataIndex: 'action',
          key: 'action',
          width: '10%',
          scopedSlots: {
            customRender: 'action'
          },
          align: 'center'
        }];
        return _columns2;
      }
    }
  },
  methods: {
    /* 上一步 */prevStep: function prevStep() {
      this.$emit('prevStep');
    },
    /* 子组件关闭的方法 */getVisible: function getVisible(visible) {
      this.importVisible = visible;
    },
    handleChange: function handleChange(info) {
      var _this2 = this;
      var fileList = _toConsumableArray(info.fileList);
      var productStatus = 0;
      if (this.chooseproductparam.productType == 2) {
        productStatus = 1;
      }
      fileList = fileList.slice(-1);
      if (fileList[0].response != undefined) {
        var newRes = fileList[0].response;
        if (newRes.code == 200) {
          //如果有导入失败的话，需要展示出导入失败的list
          if (newRes.failList.length > 0) {
            this.importVisible = true;
            this.importObj = {
              failList: newRes.failList,
              failNum: newRes.failNum,
              successList: newRes.successList,
              successNum: newRes.successNum
            };
          }
          //如果有导入成功的话，需要吧导入成功的list，添加到列表中
          //如果原来商品list中已经存在的，以商品list中为主
          var oldProductList = _.cloneDeep(this.productList);
          _.remove(newRes.successList, function (o) {
            return oldProductList.findIndex(function (item) {
              return item.productOptionId === o.productSpecId;
            }) !== -1; //o.productSpecId != oldItem.productOptionId;
          });
          // oldProductList.forEach(oldItem => {
          // 	newRes.successList = _.remove(newRes.successList, function(o) {
          // 		return o.productSpecId != oldItem.productOptionId;
          // 	});
          // })
          if (newRes.successList.length > 0) {
            //如果商品范围类型是指定不参加的，商品的状态应该直接就是失效
            newRes.successList.forEach(function (item) {
              var newObj = {
                activityContent: '',
                activityId: null,
                id: null,
                lastUpdateTime: null,
                productName: item.goodsName,
                productNo: item.goodsNo,
                productNum: '',
                productOptionId: item.productSpecId,
                productOptionName: item.specName,
                productPrice: item.price,
                productStatus: productStatus,
                productPointNum: item.productPointNum,
                productStockNum: item.productStockNum,
                productId: item.productId
              };
              _this2.productList.push(newObj);
            });
            var newproductList = _.cloneDeep(this.productList);
            this.crrentPageProductList = newproductList.splice((this.queryParam.page - 1) * this.queryParam.size, this.queryParam.size);
            this.listTotal = this.productList.length;
            this.$message.success(this.$t("public.importsucceeded"));
          }
        } else {
          this.$message.error(this.$t("public.importfail"));
        }
      }
    },
    beforeUpload: function beforeUpload(file) {
      this.files = file;
      var extension = file.name.split('.')[1] === 'xls';
      var extension2 = file.name.split('.')[1] === 'xlsx';
      var isLt5M = file.size / 1024 / 1024 < 10;
      if (!extension && !extension2) {
        this.$message.error(this.$t("public.exportpromptone"));
        return false;
      }
      if (!isLt5M) {
        this.$message.error(this.$t("public.exportprompytwo"));
        return false;
      }
    },
    changelimit: function changelimit(type) {
      if (type == 0) {
        this.limitdis = true;
        this.chooseproductparam.buyLimitNum = '';
      } else {
        this.limitdis = false;
      }
    },
    onChange: function onChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
    onSelect: function onSelect(record, selected, selectedRows) {
      //如果选中，添加进去
      if (selected) {
        this.selectProductList = _.concat(this.selectProductList, record);
      } else {
        //取消选中，失效
        this.selectProductList = _.remove(this.selectProductList, function (o) {
          return o.productOptionId != record.productOptionId;
        });
      }
    },
    onSelectAll: function onSelectAll(selected, selectedRows, changeRows) {
      var _this3 = this;
      if (selected) {
        this.selectProductList = _.concat(this.selectProductList, changeRows);
      } else {
        changeRows.forEach(function (item) {
          //取消选中，失效
          _this3.selectProductList = _.remove(_this3.selectProductList, function (o) {
            return o.productOptionId != item.productOptionId;
          });
        });
      }
    },
    /* 切换批量失效类型 */removeTypeChange: function removeTypeChange() {},
    removeModal: function removeModal() {
      var _this4 = this;
      this.$refs.ruleRemoveForm.validate(function (valid) {
        if (valid) {
          //判断是 选择的值，还是 当前页，还是全部页
          var lodingData = [];
          console.log(_this4.modalValue.removeType);
          if (_this4.modalValue.removeType == 0) {
            lodingData = _.cloneDeep(_this4.selectProductList);
          } else if (_this4.modalValue.removeType == 1) {
            lodingData = _.cloneDeep(_this4.crrentPageProductList);
          } else {
            lodingData = _.cloneDeep(_this4.productList);
          }
          //1.首先判断是 折扣 还是 数量 或者是移除
          if (_this4.buttonType == 0) {
            //折扣
            lodingData.forEach(function (item) {
              _this4.productList.forEach(function (productItem) {
                if (item.productOptionId == productItem.productOptionId) {
                  productItem.activityContent = _this4.modalValue.discount;
                }
              });
            });
          } else if (_this4.buttonType == 1) {
            //数量
            lodingData.forEach(function (item) {
              _this4.productList.forEach(function (productItem) {
                if (item.productOptionId == productItem.productOptionId) {
                  productItem.productNum = _this4.modalValue.productNum;
                }
              });
            });
          } else {
            //移除
            lodingData.forEach(function (item) {
              _this4.productList = _.remove(_this4.productList, function (o) {
                return o.productOptionId != item.productOptionId;
              });
            });
            //移除过以后需要重新 获取一下当前页，要不然无法连续移除
            var newlist = _.cloneDeep(_this4.productList);
            _this4.crrentPageProductList = newlist.splice((_this4.queryParam.page - 1) * _this4.queryParam.size, _this4.queryParam.size);
          }
          //如果商品list为 0 那么需要把分页的页码重置
          if (_this4.productList.length == 0) {
            _this4.queryParam.page = 1;
          }
          _this4.listTotal = _this4.productList.length;
          _this4.selectedRowKeys = [];
          _this4.selectNumber = 0;
          _this4.removeTypeVisible = false;
        }
      });
    },
    resetFormDate: function resetFormDate() {
      this.removeTypeVisible = false;
    },
    //批量设置按钮
    removeClick: function removeClick(type) {
      this.buttonType = type;
      if (type == 0) {
        this.dialogStatus = 'batchoff';
        this.modalValue.discount = '';
      } else if (type == 1) {
        this.dialogStatus = 'batchnumber';
        this.modalValue.productNum = '';
      } else {
        this.dialogStatus = 'batchinvalid';
      }
      this.modalValue.removeType = 0;
      this.removeTypeVisible = true;
    },
    tableChange: function tableChange(pagination, filters, sorter, _ref) {
      var currentDataSource = _ref.currentDataSource;
      this.sortedInfo = sorter;
      if (sorter.columnKey) {
        if (typeof sorter.order == "undefined") {
          sorter.order = "ascend";
        }
        if (sorter.order == "ascend") {
          this.productList = _.orderBy(this.productList, ['productStatus'], ['asc']);
        } else {
          this.productList = _.orderBy(this.productList, ['productStatus'], ['desc']);
        }
      }
      this.queryParam.page = pagination.current;
      this.queryParam.size = pagination.pageSize;
      var newlist = _.cloneDeep(this.productList);
      //初始肯定是第一页，那么需要截取第一页的数据
      this.crrentPageProductList = newlist.splice((this.queryParam.page - 1) * this.queryParam.size, this.queryParam.size);
    },
    importProduct: function importProduct() {},
    saveActivity: function saveActivity() {
      var _this5 = this;
      this.basicInformation.productType = this.chooseproductparam.productType, this.basicInformation.nameList = this.basicInformation.multilingualList,
      //第一版是 单品打折全部商品和指定不参加 不需要 设置参与件数
      // productNum: this.addProductIds,
      this.basicInformation.activityContent = this.chooseproductparam.activityContent,
      //第一版没有限购设置，直接设置为0
      this.basicInformation.buyLimit = 0,
      // this.basicInformation.buyLimitNum = this.chooseproductparam.buyLimitNum,
      this.basicInformation.productList = this.productList;

      //这里判断，全部参加，指定不参加的积分倍数是否填写
      var passed = true;
      if (this.chooseproductparam.productType != 1) {
        this.$refs.rangeRuleForm.validate(function (validtwo) {
          if (validtwo) {
            passed = true;
          } else {
            passed = false;
            console.log('error submit!!');
            return false;
          }
        });
      } else {
        passed = true;
      }
      if (passed) {
        var updateTure = true;
        if (this.chooseproductparam.productType != 0 && this.chooseproductparam.productType == 1) {
          if (this.basicInformation.productList.length != 0) {
            this.basicInformation.productList.forEach(function (item) {
              if (item.activityContent === '' || item.activityContent == null) {
                return updateTure = false;
              }
            });
          } else {
            updateTure = false;
          }
        }
        if (updateTure) {
          this.updateLoading = true;
          addActivity(this.basicInformation).then(function (response) {
            if (response.data.code == 200) {
              _this5.$message.success(_this5.$t('public.addSuccessfully'));
              _this5.$emit('nextStep');
            } else {
              _this5.$message.error(_this5.$t('public.addfail'));
            }
            _this5.updateLoading = false;
          });
        } else {
          this.$message.warning(this.$t('activity.isnull'));
        }
      }
    },
    /* 添加按钮 */addNewProduct: function addNewProduct() {
      this.visible = true;
    },
    /* 操作上的失效 */confirm: function confirm(record) {
      this.productList = _.remove(this.productList, function (o) {
        return o.productOptionId != record.productOptionId;
      });
      //移除过以后需要重新 获取一下当前页，要不然无法批量设置值
      var newlist = _.cloneDeep(this.productList);
      this.crrentPageProductList = newlist.splice((this.queryParam.page - 1) * this.queryParam.size, this.queryParam.size);
      this.listTotal = this.productList.length;
      this.$message.success(this.$t('public.removalsucceeded'));
    },
    /* 切换商品范围 */rangetypeChange: function rangetypeChange() {
      //如果切换了商品范围，那么原来失效的商品ids 清空
      this.deleteProductIds = [];
      if (this.chooseproductparam.productType == 1) {
        this.productList = _.cloneDeep(this.yesAvailableList);
      } else if (this.chooseproductparam.productType == 2) {
        this.productList = _.cloneDeep(this.notAvailableList);
      }
      //总条数清空
      this.listTotal = this.productList.length;
      //积分翻倍清空
      this.chooseproductparam.activityContent = '';
      // this.$refs.rangeRuleForm.validateField(["activityContent"])
    },
    cancel: function cancel(e) {
      // this.$message.error(this.$t('public.cancelSuccessfully'));
    }
  }
};